import React from "react";

export const CorporateCampus = [
  <div className="slideContainer slide_TextImageRight">
    <h4 className="slideTitle">De duurzame Shell Campus in Den Haag</h4>
    <p>
      Shells eigen vestigingen in Nederland zijn ook op weg naar een groenere
      toekomst. De komende jaren renoveert Shell haar hoofdkantoor, gevestigd
      aan de Haagse Carel van Bylandtlaan, met als ambitie een duurzame,
      energiezuinige (label A) Shell Campus.
    </p>
    <p>
      De focus van het renovatieproject ligt in 2021 vooral op de grootschalige
      restauratie van het monumentale pand aan Carel van Bylandtlaan 30, kortweg
      C30 genoemd. Het gebouw staat sinds enige tijd in de steigers en wordt
      getransformeerd tot een modern kantoor, met respect voor de historische
      elementen van het gebouw en een duurzaamheidsambitie op het behalen van
      LEED-Gold certificering. LEED staat voor Leadership in Energy and
      Environmental Design en is een certificeringssysteem voor duurzaamheid van
      gebouwen.
    </p>
    <p>
      Een aantal voorbeelden van duurzame toepassingen zijn het uitbreiden van
      de warmte-koudeopslag (WKO). WKO is een duurzame methode om energie in de
      vorm van warmte of koude op te slaan in de bodem en zorgt voor het koelen
      en verwarmen van het gebouw. Daarnaast is het gebouw extra goed
      geïsoleerd. Alle 2400 ramen zijn vervangen door nieuw driedubbel glas voor
      optimale isolatie. Gedurende de hele renovatie draagt het scheiden van
      bouwafval bij aan een zo efficiënt mogelijke afvalverwerking met de minste
      impact op het milieu.
    </p>
  </div>,
  <div className="slideContainer slide_TextImageRight">
    <h4 className="slideTitle">
      Shell Technology Centre Amsterdam nagenoeg CO<sub>2</sub>-neutraal
    </h4>
    <p>
      Shells eigen faciliteiten in Nederland zijn ook op weg naar een groenere
      toekomst. Een van de faciliteiten van Shell in Nederland is het Shell
      Technology Centre Amsterdam (STCA). Het is een van de drie belangrijkste
      onderzoekscentra van Shell wereldwijd en hier staat
      technologieontwikkeling centraal. Dit 90.000 m² grote gebouw heeft
      natuurlijk ook energie nodig. Het STCA heeft dan ook 196 zonnepanelen voor
      directe energievoorziening. Daarnaast doet Shell Nederland een proef met
      een nieuw soort gevelmateriaal dat maximale energieopwekking combineert
      met een kleurrijk ontwerp. De temperatuur wordt geregeld via ondergrondse
      warmte- en koudeopslag samen met warmtepompen, die gebruikmaken van de
      elektriciteit van Nederlandse windparken. De vier bronnen, twee warmte en
      twee koud, zitten op een diepte van ongeveer 180 meter.
    </p>
    <p>
      In de winter leveren de warmtebronnen water om het gebouw mee te
      verwarmen. Zodra dit is afgekoeld, wordt het opgeslagen in de koudebronnen
      in de bodem. Het koelen van het gebouw in de zomer kan door middel van
      koud water. Als het water dan weer opgewarmd is, wordt het teruggevoerd
      naar de warme bronnen voor opslag.
    </p>
    <p>
      Deze combinatie van duurzame energiesystemen zorgt ervoor dat Shells
      laboratorium aan het IJ in Amsterdam nagenoeg CO<sub>2</sub>-neutraal is.
    </p>
  </div>,
  <div className="slideContainer slide_TextImageRight">
    <h4 className="slideTitle">Werknemers STCA delen waterstofauto’s</h4>
    <div className="slideText">
      <p>
        Rijden op waterstof is een manier om de milieubelasting van mobiliteit
        te verminderen. Op het terrein van het Shell Technology Centre in
        Amsterdam-Noord staat een eigen waterstofpomp. Deze is in 2019 in
        gebruik genomen. De waterstof wordt deels geproduceerd met de
        elektriciteit die wordt opgewekt door de 168 zonnepanelen die op het dak
        liggen. Zo laat deze pomp als eerste in de regio Amsterdam het groene
        productieproces van rijden op waterstof zien, vanaf de energie opgewekt
        door de zon tot aan de uitstoot van enkel waterdamp uit de auto.
        Medewerkers van Shell Amsterdam kunnen twee waterstof deelauto’s
        gebruiken voor hun zakelijke kilometers.
      </p>
      <p>
        Hoe werkt rijden op waterstof eigenlijk? Water wordt in een zogenaamde
        elektrolyzer met behulp van stroom gesplitst in waterstof en zuurstof.
        De waterstof gaat de auto in, daar wordt het door toevoeging met
        zuurstof omgezet in elektriciteit en daar rijdt de auto dan op. Het
        duurt ongeveer vijf minuten om vijf kilogram waterstof te tanken en daar
        kun je 500 kilometer mee rijden.
      </p>
    </div>
    <div className="slideImage">
      <img
        src="images/Werknemers-STCA-delen-waterstofauto.jpg"
        alt=""
        width="560"
        height="auto"
      />
    </div>
  </div>,
  <div className="slideContainer slide_TextImageRight">
    <h4 className="slideTitle">
      Shell viert samen met nieuwe partners de opening van de Energy Transition
      Campus Amsterdam
    </h4>
    <p>
      Vandaag, 2 juni 2022, vieren Shell en innovatiepartners samen de officiële
      opening van de Energy Transition Campus Amsterdam (ETCA), de voedingsbodem
      van technologische innovaties voor een volledig duurzame en circulaire
      maatschappij.
    </p>
    <p>
      In oktober 2021 kondigde Shell aan haar onderzoeks- en
      ontwikkelingsfaciliteiten op de noordelijke oevers van het IJ in Amsterdam
      te openen voor veelbelovende start-ups, scale-ups, academici en bedrijven
      die werken aan de energietransitie.
    </p>
    <p>
      Sinds de aankondiging toonden vele partijen interesse om deel te nemen aan
      de campus. Om die reden kon het ETCA op de dag van de officiële opening
      meteen al de eerste twaalf nieuwe deelnemers bekend maken. Stuk voor stuk
      spannen ze zich in om de energietransitie te versnellen.
    </p>
    <p>
      “De campus is een prachtig staaltje werk”, zegt burgemeester van Amsterdam
      Femke Halsema op het event. “Met de ETCA gaan we de klimaatdoelen voor
      onze kinderen halen. Het is een innovatieve, duurzame en internationale
      locatie, waar mensen uit vijftig landen werken. Een locatie die heel goed
      past bij de metropool die Amsterdam graag wil zijn. Het werk aan duurzame
      oplossingen hier zal van enorme waarde zijn voor de stad.”
    </p>
    <p>
      Tot de eerste leden van de Energy Transition Campus Amsterdam behoren
      energienetwerkbedrijf Alliander, multidisciplinair ingenieursbedrijf IPSS,
      geavanceerd technologieaanbieder Kongsberg, AI-softwaremaker C3.AI,
      Technip Energy, datakennisbedrijf Databricks, ontwikkelaar van
      batterijtechnologie voor de scheepvaart Corvus Energy, start-up Finno
      Exergy, Yokogawa, IT-dienstverlener Accenture, de Universiteit Utrecht en
      ontwikkelaar van bio-alternatieven Vertoro.
    </p>
    <p>
      “Medewerkers van Shell werken in Amsterdam al meer dan honderd jaar samen
      aan innovatie en ontwikkeling”, zegt president-directeur van Shell
      Nederland Marjan van Loon. “De urgentie van de energietransitie vraagt om
      samenwerking. Wij openen onze deuren opdat instituten, universiteiten,
      bedrijven, start-ups, scale-ups hier samen kunnen werken aan het vinden
      van innovatieve oplossingen voor de energietransitie.”
    </p>
    <p>
      Shell verwelkomt de nieuwe deelnemers op de plek waar het bedrijf al in
      1914 haar onderzoeks- en ontwikkelactiviteiten startte. Onderzoek dat vele
      innovaties voortbracht en vrij recent nog leidde tot bijvoorbeeld de
      productie van 500 liter duurzame vliegtuigbrandstof (SAF) voor een vlucht
      van Amsterdam naar Madrid. Andere activiteiten omvatten onder meer
      digitalisering, kunstmatige intelligentie (AI), 3D-printen, circulaire
      chemicaliën voor dagelijkse producten en duurzame energieoplossingen,
      waaronder CO<sub>2</sub>-hergebruik en -opslag, elektrificatie en waterstof.
    </p>
  </div>,
];
